import { render } from "./columnTrainingInfo.vue?vue&type=template&id=16aae665&scoped=true&ts=true"
import script from "./columnTrainingInfo.vue?vue&type=script&lang=ts"
export * from "./columnTrainingInfo.vue?vue&type=script&lang=ts"

import "./columnTrainingInfo.vue?vue&type=style&index=0&id=16aae665&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16aae665"]])

export default __exports__